import { Injectable } from '@angular/core';
import { HttpService } from "./httpService";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContentServiceService {

  constructor(private httpService: HttpService) { }
  requestId = Number(new Date());

  getContentById(json, endpoint) {
    console.log("Json", json)
    var url = environment.cmsEndPoint + endpoint + "?requestId=" + this.requestId;
    let postData = json;
    let httpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      "accept": "application/json",
      "X-User-Id": environment.userId
    });
    console.log("httpheader ", httpHeaders)
    let options = {
      headers: httpHeaders
    }
    return this.httpService.sendPostRequestData(url, postData, options)
  }

  getGameContentById(json, endpoint) {
    console.log("Json", json)
    var url = environment.cmsEndPoint + endpoint;
    let postData = json;
    let httpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
      "accept": "application/json",
      "X-User-Id": environment.userId
    });
    console.log("httpheader ", httpHeaders)
    let options = {
      headers: httpHeaders
    }
    return this.httpService.sendPostRequestData(url, postData, options)
  }

}
